import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import PokemonCard from "../PokemonCard";
import SelectionArrow from "../SelectionArrow";
import loader from "../../assets/loader-ramolos.gif";

function PageStat() {
  /****      Déclaration des variables      ****/
  const { id } = useParams();
  const [pokemonSelected, setPokemonSelected] = useState();
  const [pageStatBackground, setPageStatBackground] = useState("");
  const [colorTitle, setColorTitle] = useState("text-gray-800");
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  /*****************************************************/
  /****    Fonction pour changer le BackGround      ****/
  /*****************************************************/
  const changeBackground = (arrayType) => {
    let type = "";
    if (arrayType.length === 1) {
      type = arrayType[0].name;
    } else {
      type = arrayType[1].name;
    }

    switch (type) {
      case "Normal":
        setPageStatBackground(`bg-[url('./assets/bg-type-normal.png')]`); //
        setColorTitle("text-gray-800");
        break;
      case "Combat":
        setPageStatBackground(`bg-[url('./assets/bg-type-combat.png')]`);
        setColorTitle("text-[#022E51]");
        break;
      case "Vol":
        setPageStatBackground(`bg-[url('./assets/bg-type-vol.png')]`);
        setColorTitle("text-[#FAE6B1]");
        break;
      case "Poison":
        setPageStatBackground(`bg-[url('./assets/bg-type-poison.png')]`);
        setColorTitle("text-[#FFCB05]");
        break;
      case "Sol":
        setPageStatBackground(`bg-[url('./assets/bg-type-sol.png')]`);
        setColorTitle("text-[#BAAEAE]");
        break;
      case "Roche":
        setPageStatBackground(`bg-[url('./assets/bg-type-roche.png')]`);
        setColorTitle("text-[#BAAEAE]");
        break;
      case "Insecte":
        setPageStatBackground(`bg-[url('./assets/bg-type-insecte.png')]`);
        setColorTitle("text-[#FFCB05]");
        break;
      case "Spectre":
        setPageStatBackground(`bg-[url('./assets/bg-type-spectre.png')]`);
        setColorTitle("text-[#F2EBE5]");
        break;
      case "Acier":
        setPageStatBackground(`bg-[url('./assets/bg-type-acier.png')]`);
        setColorTitle("text-[#EDEFEE]");
        break;
      case "Feu":
        setPageStatBackground(`bg-[url('./assets/bg-type-feu.png')]`); //
        setColorTitle("text-gray-800");
        break;
      case "Eau":
        setPageStatBackground(`bg-[url('./assets/bg-type-eau.png')]`);
        setColorTitle("text-[#FFCB05]");
        break;
      case "Plante":
        setPageStatBackground(`bg-[url('./assets/bg-type-plante.png')]`);
        setColorTitle("text-[#FFF9E9]");
        break;
      case "Électrik":
        setPageStatBackground(`bg-[url('./assets/bg-type-electrik.png')]`);
        setColorTitle("text-[#2E6DB5]");
        break;
      case "Psy":
        setPageStatBackground(`bg-[url('./assets/bg-type-psy.png')]`);
        setColorTitle("text-[#FFF9E9]");
        break;
      case "Glace":
        setPageStatBackground(`bg-[url('./assets/bg-type-glace.png')]`);
        setColorTitle("text-[#1B376D]");
        break;
      case "Dragon":
        setPageStatBackground(`bg-[url('./assets/bg-type-dragon.png')]`);
        setColorTitle("text-[#31383F]");
        break;
      case "Ténèbres":
        setPageStatBackground(`bg-[url('./assets/bg-type-tenebres.png')]`);
        setColorTitle("text-[#B3DEE5]");
        break;
      case "Fée":
        setPageStatBackground(`bg-[url('./assets/bg-type-fee.png')]`);
        setColorTitle("text-[#FFCB05]");
        break;
      default:
        setPageStatBackground(`bg-[url('./assets/bg-type-normal.png')]`);
        setColorTitle("text-gray-800");
    }
  };

  /*****************************************************/
  /****   Déclaration et Invocation de la requete   ****/
  /*****************************************************/
  const sendRequest = useCallback((endRequest) => {
    let requestURL = "https://pokebuildapi.fr/api/v1/pokemon/" + endRequest;

    fetch(requestURL)
      .then((res) => {
        if (res.status === 500) {
          return setError("Pas de pokemon trouvés");
        } else {
          setIsLoading(false);
          return res.json();
        }
      })
      .then((value) => {
        /*console.log(value); a conserver pour voir la reponse*/
        setPokemonSelected(value);
        changeBackground(value.apiTypes);
      })

      .catch(function (err) {});
  }, []);

  useEffect(() => {
    sendRequest(id);
  }, [sendRequest, id]);

  /*****************************************************/
  /****                 Dom virtuel                 ****/
  /*****************************************************/
  return (
    <div
      className={`pt-52 ${pageStatBackground} min-h-screen bg-cover bg-center`}
    >
      <SelectionArrow pokemonId={parseInt(id)} />
      {isLoading && (
        <div className="text-center">
          <img src={loader} alt="" className="block m-auto" />
          <h2>CHARGEMENT</h2>
        </div>
      )}
      {pokemonSelected ? (
        <PokemonCard
          pokemonSelected={pokemonSelected}
          colorTitle={colorTitle}
        />
      ) : null}
      {error && <div className="error">{error}</div>}
    </div>
  );
}

export default PageStat;
